import React from 'react';
import { IconButton, Input, InputGroup, InputLeftElement, InputRightElement } from '@chakra-ui/react';
import { MdClose, MdSearch } from 'react-icons/md';
import { streamGhostOnDarkHover } from '../darkThemeButtonProps';

interface Props {
  value: string;
  onChange: (v: string) => void;
  placeholder?: string;
  /** Narrow columns (category rail / sidebar) */
  compact?: boolean;
}

export function SearchBar({ value, onChange, placeholder = 'Search…', compact }: Props) {
  const sz = compact ? 'sm' : 'md';
  const iconSz = compact ? 16 : 20;
  const hasText = value.length > 0;
  const rightPad = hasText ? (compact ? 10 : 11) : compact ? 8 : 10;
  return (
    <InputGroup size={sz} maxW="100%" w="100%">
      <InputLeftElement pointerEvents="none" color="whiteAlpha.500" h={compact ? '32px' : undefined}>
        <MdSearch size={iconSz} />
      </InputLeftElement>
      <Input
        pl={compact ? 8 : 10}
        pr={rightPad}
        fontSize={compact ? 'xs' : undefined}
        h={compact ? '32px' : undefined}
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder={placeholder}
        bg="whiteAlpha.100"
        border="1px solid"
        borderColor="whiteAlpha.200"
        color="white"
        _placeholder={{ color: 'whiteAlpha.400' }}
        _hover={{ borderColor: 'whiteAlpha.300' }}
        _focus={{ borderColor: 'teal.400', boxShadow: '0 0 0 1px var(--chakra-colors-teal-400)' }}
        borderRadius="xl"
      />
      {hasText && (
        <InputRightElement
          h={compact ? '32px' : '40px'}
          w={compact ? '32px' : '40px'}
          pr={compact ? 0.5 : 1}
        >
          <IconButton
            aria-label="Clear search"
            icon={<MdClose size={compact ? 16 : 18} />}
            size={compact ? 'xs' : 'sm'}
            variant="ghost"
            color="whiteAlpha.600"
            minW={compact ? '24px' : undefined}
            h={compact ? '24px' : undefined}
            {...streamGhostOnDarkHover}
            onClick={() => onChange('')}
          />
        </InputRightElement>
      )}
    </InputGroup>
  );
}
